export const selectChatsState = (state) => state.chats;
export const selectNewMessageCount = (state) => state.chats?.newMessageCount;
export const selectSelectedChatId = (state) => state.chats?.selectedChatId;
export const selectTopicQuestions = (state) => state.chats?.topicQuestions;
